<template>
  <div>
    <vetster-breadcrumbs
      :trail="trail"
      class="block mb-8 lg:mb-14"
    />
    <vetster-editorial-top-center-title
      :title="post.title"
      :description="post.description"
    />
    <vetster-publish-date
      :post="post"
      :is-stacked="false"
    />
    <div class="block lg:hidden mt-6">
      <vetster-author-group
        :author="post.author"
        :verified-author="post.verified_author"
        :is-stacked="false"
      />
    </div>
  </div>
</template>

<script>
import VetsterBreadcrumbs from '@/brand-components/Content/BlogPost/VetsterBreadcrumbs';
import VetsterEditorialTopCenterTitle from '@/brand-components/Content/BlogPost/VetsterEditorialTopCenterTitle';
import VetsterAuthorGroup from '@/brand-components/Content/VetsterAuthorGroup';
import VetsterPublishDate from '@/brand-components/Content/VetsterPublishDate';
import LocalizesRoutes from '@/mixins/LocalizesRoutes';

export default {
  name: 'VetsterEditorialTopCenterContent',

  components: {
    VetsterAuthorGroup,
    VetsterBreadcrumbs,
    VetsterEditorialTopCenterTitle,
    VetsterPublishDate,
  },

  mixins: [LocalizesRoutes],

  props: {
    post: {
      type: Object,
      required: true,
    },
  },

  computed: {
    trail() {
      return [
        {
          name: this.$t('app.pet-connection'),
          url: this.localizeLanguageUrl('/pet-connection'),
        },
        {
          name: this.post.post_type?.title,
          url: this.localizeLanguageUrl(this.post.post_type?.slug),
        },
      ];
    },
  },
};
</script>
